import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import Styles from './styles.module.css';

export default class About extends Component{
    private videoId = '890276880';

    render(){
        return (
            <>
                <Container fluid className={Styles.container}>
                    <Row>
                        <Col xs="12">
                            <div className={Styles.vimeoContainer}>
                                <iframe className={Styles.vimeoPlayer} src={`https://player.vimeo.com/video/${this.videoId}`} frameBorder="0" allowFullScreen/>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12">
                            <p className={Styles.text}>
                            Documentary film production company based in Germany, Poland and Ukraine. The company was created by Roman Blazhan and Mykhailo Volkov in 2015.

                            </p>
                        </Col>
                    </Row>
                </Container>
            </>
        )
    }
}